import axios from 'axios';
import SessionService from './session.js';
import tokenService from './token.service.js';
import { appConfig } from '../config/appConfig.js';
import { Alert } from 'bootstrap';
import { isErrorExist } from '../utils/validAndTest.js';
import { jwtDecode } from 'jwt-decode';

class ApiService {

    axiosClient= axios.create({
        baseURL: appConfig.RESTPOINT_URL,
        headers: {
            'Content-Type': 'application/json',
          },
    })

    validateUserData = (userInfo, isFormSubmission) => {
        const body = {
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          email: userInfo.email,
          access_token: SessionService.accessTokenWithoutBearer(),
          id_token: SessionService.idToken(),
          client_id: tokenService.getFromMobile()?appConfig.CLIENT_ID_MOBILE:appConfig.CLIENT_ID_WEB,
          isRecord: tokenService.getUserRecordExist(),
        };
    
        let jwtToken = body.id_token;
        if (jwtToken) {
          const identities =  tokenService.extractIdentitiesFromJwt(jwtToken);
          if (identities) {
            body.identities = identities;
          }
        }

        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body)
        };
    
        const url = `${appConfig.RESTPOINT_URL}/api/rest/restpoints/community_hub/validate`;
      
        fetch(url, requestOptions)
          .then(response => {
            if(response?.status === 204){
              tokenService.removeErrorData();
              this.validateUrl();
            }

            if(isErrorExist(response?.status)) {
              tokenService.setErrorData(true);
              window.location.replace(SessionService.redirectUri());
            }
          })
          .catch(error => {
            // Handle any errors
            console.log('err', error);
          });
    
      }
    
    validateUrl = () => {
      const body = {
        access_token: SessionService.accessTokenWithoutBearer(),
        id_token: SessionService.idToken(),
        client_id: tokenService.getFromMobile()?appConfig.CLIENT_ID_MOBILE:appConfig.CLIENT_ID_WEB,
        url: tokenService.getRedirectUrlPath()
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      };
  
      const url = `${appConfig.RESTPOINT_URL}/api/rest/restpoints/community_hub/validateURL`;
    
      fetch(url, requestOptions)
        .then(response => {
          if(response?.status === 204){
            tokenService.removeErrorData();
            window.location.replace(tokenService.getRedirectUrl());
          }

          if(isErrorExist(response?.status)) {
            tokenService.setErrorData(true);
            window.location.replace(SessionService.redirectUri());
          }
        });
  
    }
}

export default new ApiService();
